var styleDataHash = "7ace1dbd";
const injectCss = () => {
  var css = `.ig9vn{box-sizing:border-box;display:flex;flex-direction:column;width:162px;z-index:10}[dir] .ig9vn{background-color:#fff}.ig9vn *,.ig9vn :after,.ig9vn :before{box-sizing:inherit}.ig9vn input{box-sizing:border-box}@supports not (contain:inline-size){@media only screen and (max-width:640px){.ig9vn{width:100%}}}@container (width < 640px){.ig9vn{width:100%}}.t1CQd{align-items:flex-start;align-items:center;display:flex;flex-direction:column;width:100%}[dir] .t1CQd{padding:8px 0}.t1CQd:focus-visible{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var DropdownModal_default = {
  "modal": "ig9vn",
  "dropdownModalOptionsWrapper": "t1CQd"
};
export {
  DropdownModal_default as default,
  injectCss
};
//# sourceMappingURL=DropdownModal-scss.js.map
